export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const RECEIVE_CONFIG = 'RECEIVE_CONFIG';
export const RECEIVE_PRODUCT_TEMPLATES = 'RECEIVE_PRODUCT_TEMPLATES';
export const RECEIVE_CREATION_TEMPLATES = 'RECEIVE_CREATION_TEMPLATES';
export const CLEAR_CREATION_TEMPLATES = 'CLEAR_CREATION_TEMPLATES';
export const NAVIGATE = 'NAVIGATE';
export const PRODUCT_SELECT_ALL = 'PRODUCT_SELECT_ALL';
export const PRODUCT_DESELECT_ALL = 'PRODUCT_DESELECT_ALL';
export const OPEN_HAMBURGER_NAV = 'OPEN_HAMBURGER_NAV';
export const CLOSE_HAMBURGER_NAV = 'CLOSE_HAMBURGER_NAV';
export const PRODUCT_DELETE_RECEIVE = 'PRODUCT_DELETE_RECEIVE';
export const PRODUCT_UPDATE = 'PRODUCT_UPDATE';
export const PRODUCT_DISABLE = 'PRODUCT_DISABLE';
export const PRODUCT_ENABLE = 'PRODUCT_ENABLE';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const CLEAR_ALL_TOAST = 'CLEAR_ALL_TOAST';
export const PRODUCT_SETTINGS = 'PRODUCT_SETTINGS';
export const RESET_PRODUCT_SETTINGS = 'RESET_PRODUCT_SETTINGS';
export const CREATION_CLEAR_SEARCH = 'CREATION_CLEAR_SEARCH';
export const CREATION_SEARCH_TEMPLATES = 'CREATION_SEARCH_TEMPLATES';
export const REQUEST_CREATION_TEMPLATES = 'REQUEST_CREATION_TEMPLATES';
export const LOAD_MORE_CREATION_TEMPLATES = 'LOAD_MORE_CREATION_TEMPLATES';
export const ERROR_CREATION_TEMPLATES = 'ERROR_CREATION_TEMPLATES';
export const SAVE_PARENT_LOCATION = 'SAVE_PARENT_LOCATION';
export const NEW_PRODUCT_CREATION = 'NEW_PRODUCT_CREATION';
export const PRODUCTS_CLEAR = 'PRODUCTS_CLEAR';
export const PRODUCT_CHANGE = 'PRODUCT_CHANGE';
export const UNDO_DELETE = 'UNDO_DELETE';
export const CART_UPDATE = 'CART_UPDATE';
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';
export const SWITCH_WEBSITE = 'SWITCH_WEBSITE';

// UI Notification Actions
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';

export const DISMISS_SIDENAV_ANNOUNCEMENT = 'DISMISS_SIDENAV_ANNOUNCEMENT';

// FAQ Actions
export const FAQ_OPEN = 'FAQ_OPEN';
export const FAQ_EMAIL = 'FAQ_EMAIL';

export type Action = {
  type: string,
  value?: any,
};

// My Account Actions
export const REQUEST_UPDATE_ACCOUNT_DETAILS = 'REQUEST_UPDATE_ACCOUNT_DETAILS';
export const RECEIVE_UPDATE_ACCOUNT_DETAILS = 'RECEIVE_UPDATE_ACCOUNT_DETAILS';
export const REQUEST_UPDATE_ACCOUNT_ADDRESS = 'REQUEST_UPDATE_ACCOUNT_ADDRESS';
export const RECEIVE_UPDATE_ACCOUNT_ADDRESS = 'RECEIVE_UPDATE_ACCOUNT_ADDRESS';

// Approvals Actions
export const REQUEST_APPROVALS = 'REQUEST_APPROVALS';
export const RECEIVE_APPROVALS = 'RECEIVE_APPROVALS';
export const REQUEST_APPROVALS_COUNT = 'REQUEST_APPROVALS_COUNT';
export const RECEIVE_APPROVALS_COUNT = 'RECEIVE_APPROVALS_COUNT';
export const REQUEST_UPDATE_APPROVAL_STATUS = 'REQUEST_UPDATE_APPROVAL_STATUS';
export const RECEIVE_UPDATE_APPROVAL_STATUS = 'RECEIVE_UPDATE_APPROVAL_STATUS';
export const RECEIVE_UPDATE_APPROVAL_STATUS_ERROR = 'RECEIVE_UPDATE_APPROVAL_STATUS_ERROR';
export const RECEIVE_APPROVALS_UNAUTHORIZED = 'RECEIVE_APPROVALS_UNAUTHORIZED';

// Accessories Actions
export const REQUEST_ACCESSORIES = 'REQUEST_ACCESSORIES';
export const RECEIVE_ACCESSORIES = 'RECEIVE_ACCESSORIES';
export const REQUEST_ACCESSORY = 'REQUEST_ACCESSORY';
export const RECEIVE_ACCESSORY = 'RECEIVE_ACCESSORY';
export const REQUEST_ACCESSORY_PRICE = 'REQUEST_ACCESSORY_PRICE';
export const RECEIVE_ACCESSORY_PRICE = 'RECEIVE_ACCESSORY_PRICE';
export const ADD_ACCESSORY_TO_CART = 'ADD_ACCESSORY_TO_CART';
export const ADDED_ACCESSORY_TO_CART = 'ADDED_ACCESSORY_TO_CART';
export const ACCESSORY_QUANTITY_CHANGE = 'ACCESSORY_QUANTITY_CHANGE';
export const ACCESSORY_VARIANT_CHANGE = 'ACCESSORY_VARIANT_CHANGE';

// Dashboard Actions
export const REQUEST_DASHBOARD_DATA = 'REQUEST_DASHBOARD_DATA';
export const RECEIVE_DASHBOARD_DATA = 'RECEIVE_DASHBOARD_DATA';
export const REQUEST_ORDERS = 'REQUEST_ORDERS';
